import PropTypes from 'prop-types';

const checkboxTheme = {
  activeColor: PropTypes.string,
  inactiveColor: PropTypes.string,
  fill: PropTypes.string,
};

export default checkboxTheme;
